import e, { Component as r } from "react";
import { ErrorSummary as t } from "./ErrorSummary/index.js";
import { componentName as n } from "../../../utils/bem/index.js";
import { t as o } from "../../../i18/index.js";
function i(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function s(e, r, t, n, o, i, s) {
  try {
    var l = e[i](s),
      a = l.value;
  } catch (e) {
    t(e);
    return;
  }
  l.done ? r(a) : Promise.resolve(a).then(n, o);
}
function l(e, r) {
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function a(e, r, t) {
  return r in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function u(e) {
  return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function c(e, r) {
  return (c = Object.setPrototypeOf || function (e, r) {
    return e.__proto__ = r, e;
  })(e, r);
}
var p = function (r) {
  !function (e, r) {
    if ("function" != typeof r && null !== r) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(r && r.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), r && c(e, r);
  }(h, r);
  var t,
    p,
    f,
    d = (t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        r,
        n = u(h);
      if (t) {
        var o = u(this).constructor;
        r = Reflect.construct(n, arguments, o);
      } else r = n.apply(this, arguments);
      return (e = r) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : i(this);
    });
  function h() {
    !function (e, r) {
      if (!(e instanceof r)) throw TypeError("Cannot call a class as a function");
    }(this, h), r = d.apply(this, arguments), a(i(r), "state", {
      focused: 0
    }), a(i(r), "input", void 0), a(i(r), "errors", {}), a(i(r), "leftToProcess", void 0), a(i(r), "inProgress", void 0), a(i(r), "queue", void 0), a(i(r), "_handleClick", function () {
      r.props.openOnClick && !r.props.disabled && r.input.click();
    }), a(i(r), "openFileBrowser", function () {
      return r.input.click();
    }), a(i(r), "_handleInputChange", function (e) {
      return r._processFiles(e.target.files);
    }), a(i(r), "_shouldHandleEvent", function (e) {
      return !r.props.disabled;
    }), a(i(r), "_handleDragOver", function (e) {
      if (r._shouldHandleEvent(e) && r._hasProcessibleFiles(e)) {
        var t, n;
        e.preventDefault(), null === (t = (n = r.props).onDragOver) || void 0 === t || t.call(n, e);
      }
    }), a(i(r), "_handleDrop", function (e) {
      r._shouldHandleEvent(e) && (r.props.onDrop && r.props.onDrop(e), r._hasProcessibleFiles(e) && (e.preventDefault(), r._processFiles(e.dataTransfer.files)));
    }), a(i(r), "_handleDragEnter", function (e) {
      r._hasProcessibleFiles(e) && r.setState({
        focused: r.state.focused + 1
      });
    }), a(i(r), "_handleDragLeave", function () {
      r.state.focused && r.setState({
        focused: r.state.focused - 1
      });
    }), a(i(r), "_hasProcessibleFiles", function (e) {
      return Array.from(e.dataTransfer.types || []).reduce(function (e, r) {
        return e || "Files" === r;
      }, !1);
    }), a(i(r), "_processFiles", function (e) {
      var t, n;
      r.setState({
        focused: 0
      }), r.errors = {
        size: [],
        kind: [],
        excess: [],
        other: []
      }, r.leftToProcess = e.length, r.queue = [], r.inProgress = 0, null === (t = (n = r.props).onStart) || void 0 === t || t.call(n, e), Array.from(e).forEach(function (e) {
        return r._processFile(e);
      });
    }), a(i(r), "_checkMime", function (e) {
      if (!e.type) return !1;
      var t = r.props.accept.split("/"),
        n = e.type.split("/");
      return t[0] === n[0] && ("*" === t[1] || t[1] === n[1]);
    }), a(i(r), "_processFile", function (e) {
      if (e.size > r.props.maxFilesizeBytes) {
        r.errors.size.push({
          file: e,
          limit: r.props.maxFilesizeBytes / 1e6
        }), r._processComplete();
        return;
      }
      if (r.props.accept && !r._checkMime(e)) {
        r.errors.kind.push({
          file: e
        }), r._processComplete();
        return;
      }
      var t = new FileReader();
      t.onload = function () {
        r.queue.push({
          file: e
        }), r._processComplete();
      }, t.onerror = function () {
        r.errors.kind.push({
          file: e,
          kind: "folder"
        }), r._processComplete();
      }, t.readAsDataURL(e);
    }), a(i(r), "_processComplete", function () {
      r.leftToProcess--, r._sendNext();
    }), a(i(r), "_hasErrors", function () {
      for (var e in r.errors) if (r.errors[e].length > 0) return !0;
    }), a(i(r), "_handleFinish", function () {
      r.props.onDone && r.props.onDone({
        errors: r.errors
      }), r.input.value = "";
    });
    var e,
      r,
      t = i(r);
    return a(i(r), "_sendNext", (e = function e() {
      var e, r, n, o;
      return function (e, r) {
        var t,
          n,
          o,
          i,
          s = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: l(0),
          throw: l(1),
          return: l(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function l(i) {
          return function (l) {
            return function (i) {
              if (t) throw TypeError("Generator is already executing.");
              for (; s;) try {
                if (t = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return s.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    s.label++, n = i[1], i = [0];
                    continue;
                  case 7:
                    i = s.ops.pop(), s.trys.pop();
                    continue;
                  default:
                    if (!(o = (o = s.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      s = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      s.label = i[1];
                      break;
                    }
                    if (6 === i[0] && s.label < o[1]) {
                      s.label = o[1], o = i;
                      break;
                    }
                    if (o && s.label < o[2]) {
                      s.label = o[2], s.ops.push(i);
                      break;
                    }
                    o[2] && s.ops.pop(), s.trys.pop();
                    continue;
                }
                i = r.call(e, s);
              } catch (e) {
                i = [6, e], n = 0;
              } finally {
                t = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, l]);
          };
        }
      }(this, function (i) {
        switch (i.label) {
          case 0:
            if (0 === t.queue.length && 0 === t.leftToProcess && 0 === t.inProgress) return t._handleFinish(), [2];
            if (t.inProgress >= t.props.maxConcurrentUploads || 0 === t.queue.length) return [2];
            return t.inProgress++, e = t.queue.pop(), [4, t.props.uploadFile(e)];
          case 1:
            return r = i.sent(), t.inProgress--, r.error ? t.errors.other.push({
              file: e.file
            }) : null === (n = (o = t.props).onUploaded) || void 0 === n || n.call(o, r), t._sendNext(), [2];
        }
      });
    }, function () {
      var r = this,
        t = arguments;
      return new Promise(function (n, o) {
        var i = e.apply(r, t);
        function l(e) {
          s(i, n, o, l, a, "next", e);
        }
        function a(e) {
          s(i, n, o, l, a, "throw", e);
        }
        l(void 0);
      });
    })), a(i(r), "receiveInput", function (e) {
      return r.input = e;
    }), r;
  }
  return p = [{
    key: "render",
    value: function value() {
      var r = this.props.maxFilesizeBytes / 1e6,
        t = n("file-uploader", this.props.className, {
          focused: this.state.focused
        });
      return e.createElement("div", {
        className: t,
        onDragEnter: this._handleDragEnter,
        onDragLeave: this._handleDragLeave,
        onDragOver: this._handleDragOver,
        onDrop: this._handleDrop,
        onClick: this._handleClick
      }, e.createElement("div", null, e.createElement("div", null, this.props.dropMessage), e.createElement("div", {
        className: "file-uploader__max-file-size"
      }, o("file-uploader.max-file-size", {
        maxSize: r
      }))), this.props.children, e.createElement("input", {
        accept: this.props.accept,
        type: "file",
        style: {
          display: "none"
        },
        onChange: this._handleInputChange,
        multiple: !0,
        ref: this.receiveInput
      }));
    }
  }], l(h.prototype, p), f && l(h, f), h;
}(r);
a(p, "displayName", "FileUploader"), a(p, "ErrorSummary", t), a(p, "defaultProps", {
  maxFilesizeBytes: 1e8,
  maxConcurrentUploads: 2,
  openOnClick: !0
});
export { p as FileUploader };